// extracted by css-extract-rspack-plugin
export default {"recipients":"OvsYF"};